<div class="overseas-dialog">
  <div class="dialog-header">
    <h2>海外手机号登录说明</h2>
    <button class="close-btn" (click)="close()">&times;</button>
  </div>

  <div class="dialog-body">
    <p class="intro">因服务调整，海外手机号暂不支持获取短信验证码：</p>
    <div class="guide">
      <div class="guide-item">
        <span class="dot">🔹</span>
        <div class="guide-content">
          <b>未注册的新用户</b>：请使用【邮箱】注册/登录。
        </div>
      </div>
      <div class="guide-item">
        <span class="dot">🔹</span>
        <div class="guide-content">
          <div><b>已注册的老用户</b>：请切换至【密码登录】。</div>
          <div class="highlight">若未修改过，默认密码为手机号后 6 位</div>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <button class="btn-outline" (click)="goEmail()">去邮箱登录</button>
    <button class="btn-primary" (click)="goPassword()">去密码登录</button>
  </div>
</div>
